import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled, { useTheme } from 'styled-components';

import Flex from '@components/layout/flex';
import SquareImg from '@components/basics/artwork-img';
import Typography from '@components/basics/typography';
import DineroFactory from 'dinero.js';
import { useSelector } from 'react-redux';
import AppState from '@webapp/store/state';

const dineroFormatter = (earnedItem: DineroFactory.Dinero) => {
  return earnedItem.toFormat('$0,0');
};

const formatNumber = (n: number) => {
  return Intl.NumberFormat().format(n);
};

interface ArtistReleaseItemProps {
  className?: string;
  srcImg?: string;
  name?: string;
  type: string;
  quantity?: number;
  earned: DineroFactory.Dinero;
  isDarkBg?: boolean;
  isSelected?: boolean;
}

const ArtistEarningItem: FunctionComponent<ArtistReleaseItemProps> = ({
  className,
  type,
  srcImg,
  name,
  quantity,
  earned,
  isDarkBg,
  isSelected,
}) => {
  const theme = useTheme();

  const isMobile = useSelector((state: AppState) => state.ui.mobile);

  return (
    <Wrapper className={className || ''}>
      <Flex className="left">
        <SquareImg className="img" size={36} srcImg={srcImg} />
        <div>
          {name ? (
            <Typography
              className="name"
              isGrey={isDarkBg && !isSelected}
              weight="700"
              color={isDarkBg && isSelected ? theme.colors.white : undefined}
            >
              {name}
            </Typography>
          ) : null}
          <SecondaryText type="paragraph">{type}</SecondaryText>
        </div>
      </Flex>
      <Flex className="right">
        <Section className={`${isMobile ? '' : 'right-space'}`}>
          <Typography
            className="title"
            isGrey={isDarkBg && !isSelected}
            weight="700"
            color={isDarkBg && isSelected ? theme.colors.white : undefined}
          >
            {formatNumber(quantity || 0)}
          </Typography>
          <SecondaryText type="paragraph">
            <Translate
              id={
                type === 'Merch'
                  ? 'ANALYTICS.YOUR_CATALOG.SALES'
                  : 'ANALYTICS.YOUR_CATALOG.STREAMS'
              }
            />
          </SecondaryText>
        </Section>
        <Section>
          <Typography
            className="title"
            isGrey={isDarkBg && !isSelected}
            weight="700"
            color={isDarkBg && isSelected ? theme.colors.white : undefined}
          >
            {dineroFormatter(earned)}
          </Typography>
          <SecondaryText type="paragraph">
            <Translate id="ANALYTICS.YOUR_CATALOG.EARNED" />
          </SecondaryText>
        </Section>
      </Flex>
    </Wrapper>
  );
};

export default ArtistEarningItem;

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .left {
    .img {
      margin-right: 20px;
    }
    .name {
      margin-bottom: 5px;
      max-width: 94px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .right {
    gap: 20px;
    text-align: right;
    width: 50%;

    .title {
      margin-bottom: 5px;
    }
  }
`;

const SecondaryText = styled(Typography)`
  text-transform: capitalize;
  opacity: 1;
  color: ${({ theme }) => theme.colors.tertiary};
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
